import httpClient from "@/plugins/axios";

export const getFaq = async () => {
    const response = await httpClient.get('/v1/faq/?page=1&page_size=1000');
    return response;
}

